module.exports = __webpack_public_path__ + "static/img/9.51fc246d.jpg";